/** Dispatched so SideBarLayout can call PerfectScrollbar `update()` on the main region. */
export const MAIN_PERFECT_SCROLLBAR_REFRESH_EVENT =
  "securly-pass:main-perfect-scrollbar-refresh"

export function requestMainPerfectScrollbarRefresh() {
  if (typeof window === "undefined") {
    return
  }
  window.dispatchEvent(new Event(MAIN_PERFECT_SCROLLBAR_REFRESH_EVENT))
}
